/**
 * Kunci sessionStorage untuk layar kasir (Cashpay). Diberi awalan sendiri supaya tidak bentrok
 * dengan kunci login All In One, dan dihapus saat logout (AuthService.clearAuthData).
 */
export const CASHIER_STORAGE_KEYS = {
  periode: 'lc_cashier_periode',
  student: 'lc_cashier_student',
} as const;

export function clearCashierStorage(): void {
  try {
    Object.values(CASHIER_STORAGE_KEYS).forEach((key) => window.sessionStorage.removeItem(key));
  } catch {
    // sessionStorage bisa tidak tersedia (mode privat); tidak ada yang perlu dihapus.
  }
}
